export interface CreateCorporationDto {
  name: string; // Required, max 200
  description?: string | null; // Max 1000
  email: string; // Required, email, max 320
  phone?: string | null; // Phone, max 20
  website?: string | null; // URL, max 500
  logoUrl?: string | null; // URL, max 500
  address?: string | null; // Max 500
  city?: string | null; // Max 100
  state?: string | null; // Max 50
  postalCode?: string | null; // Max 20
  country?: string | null; // Max 100
  timeZone?: string | null; // Max 50
  businessHours?: string | null; // Max 500
  isActive?: boolean; // Default: true
}
